import { Component, OnInit } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';


@Component({
  selector: 'app-modal-start',
  templateUrl: './modal-start.page.html',
  styleUrls: ['./modal-start.page.scss'],
})
export class ModalStartPage implements OnInit {

  constructor(
    private navParams: NavParams, 
    private modalController: ModalController
  ) { }

  ngOnInit() {
  }
  close() {
    this.modalController.dismiss();
    localStorage.setItem("modalStart", "true");
  }

}
